import { IAddress } from '@/interfaces/Address';

import { getValueIfIsNotNil } from '@/helpers/values';
import { EAddressKind } from '@/helpers/enums';

export default class Address implements IAddress {
  public street_name: string;
  public street_number?: number|string;
  public city: string;
  public neighborhood: string;
  public state: string;
  public postal_code: string;
  public ibge_code: string;
  public country?: string = 'brasil';
  public complement?: string;
  public kind?: EAddressKind = EAddressKind.home;
  public is_default?: boolean = true;
  public is_active?: boolean = true;
  public is_billing?: boolean = true;
  public is_delivery?: boolean = true;
  public zipCodeData?: boolean = false;

  constructor(address?: IAddress) {
    if (address) {
      this.street_name = getValueIfIsNotNil(address.street_name);
      this.street_number = getValueIfIsNotNil(address.street_number);
      this.city = getValueIfIsNotNil(address.city);
      this.neighborhood = getValueIfIsNotNil(address.neighborhood);
      this.state = getValueIfIsNotNil(address.state);
      this.postal_code = getValueIfIsNotNil(address.postal_code);
      this.ibge_code = getValueIfIsNotNil(address.ibge_code);
      this.country = getValueIfIsNotNil(address.country, 'brasil');
      this.complement = getValueIfIsNotNil(address.complement);
      this.kind = getValueIfIsNotNil(address.kind, EAddressKind.home);
      this.is_default = getValueIfIsNotNil(address.is_default, true);
      this.is_active = getValueIfIsNotNil(address.is_active, true);
      this.is_billing = getValueIfIsNotNil(address.is_billing, true);
      this.is_delivery = getValueIfIsNotNil(address.is_delivery, true);
      this.zipCodeData = getValueIfIsNotNil(address.zipCodeData, false);
    }
  }
}

